<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" style="font-size: 24px;" class="pointer green" /></router-link>
                    Permissions
                    <font-awesome-icon :icon="['fa', 'plus']" style="font-size: 24px;" class="pointer green " @click="AddButton" />
                    <b-col cols="2">
                        <input class="form-control" v-model="search" type="text" placeholder="Search" aria-label="Search" @input="RedrawTable()" />
                    </b-col>
                    <span class="AddModal">
                        <b-modal @show="ClearForm" @hidden="ClearForm" ref="add-component-modal" title="Add Permission" hide-footer>
                            <b-container fluid>
                                <b-form @submit="AddPermission">
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Permission Name:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.name" placeholder="Required" type="name" required></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Permission Description:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="form.description" type="name"></b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="HideAddModal()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="primary" type="submit">
                                                CONFIRM
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>
                </h2>
                <vuetable :fields="PermissionTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          ref="datatable">
                    <template slot="PermissionActions" scope="props">
                        <div class="ChildRecordLinkFirst">
                            <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 24px;margin-right:1rem;" class="pointer orange " @click="EditPermissionButton(props.rowData)" />
                            <ActionButtonWithIcon :requires-confirmation="true"
                                      confirmation-string="WARNING: You are about to delete this permission.  Are you sure?"
                                      endpoint="Admin/UserManagement/DeletePermission"
                                      :payload="{Id: props.rowData.Id}"
                                      :perform-global-update="false"
                                      button-variant="link"
                                      button-string=""
                                      button-size="md"
                                      emit-on-success="permission-deleted"
                                      v-on:success="RefreshDataTable" 
                                      icon-prefix="fa"
                                      icon-suffix="trash-alt"
                                      icon-color="red"
                                      method="POST"/>
                        </div>
                    </template>
                </vuetable>

                <span class="EditModal">
                    <b-modal ref="edit-component-modal" title="Edit Permission" hide-footer>
                        <b-container fluid>
                            <b-form @submit="EditPermission">
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Permission Name:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.name" placeholder="Required" type="name" required></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Permission Description:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="form.description"></b-col>
                                </b-row>
                                <b-row class="modal-btn-row">
                                    <div class="modal-btn-row-div">
                                        <b-button size="md" variant="secondary" @click="HideEditModal()">
                                            CANCEL
                                        </b-button>
                                        <b-button size="md" variant="primary" type="submit">
                                            CONFIRM
                                        </b-button>
                                    </div>
                                </b-row>
                            </b-form>
                        </b-container>
                    </b-modal>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faPencilAlt);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);

    export default {
        name: "PermissionList",
        created() {
        },
        props: [],
        data: function () {
            return {
                search: "",
                PermissionList: [],
                form: {
                    Id: '',
                    name: '',
                    description: ''
                },
                PermissionTableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: 'Permission Name',
                            sortField: 'Name'
                        },
                        {
                            name: 'Description',
                            title: 'Description',
                            sortField: 'Description'
                        },
                        {
                            name: 'Roles',
                            title: 'Role',
                            sortField: 'Roles'
                        },
                        {
                            name: '__slot:PermissionActions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            ClearForm() {
                this.form.Id = '';
                this.form.name = '';
                this.form.description = '';
            },
            ShowEditModal() {
                this.$refs['edit-component-modal'].show();
            },
            HideEditModal() {
                this.$refs['edit-component-modal'].hide();
            },
            EditPermissionButton(rowData) {
                this.form.Id = rowData.Id;
                this.form.name = rowData.Name;
                this.form.description = rowData.Description;
                this.$refs['edit-component-modal'].show();
            },
            AddButton() {
                this.$refs['add-component-modal'].show();
            },
            HideAddModal() {
                this.$refs['add-component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetPermissions();
            },
            AddPermission(e) {
                e.preventDefault();
                let vm = this;
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/AddPermission",
                    {
                        Name: vm.form.name,
                        Description: vm.form.description
                    }, this.AddPermissionSuccess, () => { }, false);

            },
            AddPermissionSuccess(response) {
                this.RefreshDataTable();
                this.HideAddModal();
            },
            GetPermissions() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetPermissions",{}, this.GetPermissionsSuccess, () => { }, false);
            },
            GetPermissionsSuccess(response) {
                this.PermissionList = response.data.data;
                this.$refs.datatable.refresh();
            },
            EditPermission(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/EditPermission",{Id: this.form.Id, Name: this.form.name, Description: this.form.description }, this.EditPermissionSuccess, () => { }, false);

            },
            EditPermissionSuccess(response) {
                this.RefreshDataTable();
                this.$refs['edit-component-modal'].hide();
            },
           RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.PermissionList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;                  
            }
        },
        components: {
            Vuetable,
            ActionButtonWithIcon
        },
        computed: {
            LoadedPermissions: function () {
                return this.PermissionList;
            },
        },
        mounted() {
            var vm = this;
            this.GetPermissions();
            let getPermissionsFunc = function () {
                vm.GetPermissions();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getPermissionsFunc);
        }
    }
</script>

<style scoped>
</style>